(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["feelfit-preorder-submit"] && !Shopify.designMode) return;
  try {
    (() => {
    const boot = () => {
      const root = document.querySelector('[data-ff-cart]');
      const config = document.querySelector('[data-ff-preorder-config]')?.dataset;
      const button = root?.querySelector('[data-ff-preorder-submit]');
      if (!button || !config || button.dataset.connected) return;
      button.dataset.connected = 'true';
      const terms = root.querySelector('[data-ff-preorder-terms]');
      const instagram = root.querySelector('[name="attributes[Instagram]"]');
      const status = root.querySelector('[data-ff-preorder-status]');
      let busy = false;
      let attempt = null;
      const storageKey = 'ff_preorder_attempt_v1';
      const username = () => instagram.value.trim().replace(/^@/, '').toLowerCase();
      const sync = () => { button.disabled = busy || !terms.checked || !/^[a-z0-9._]{1,30}$/.test(username()); };
      instagram.addEventListener('input', sync);
      terms.addEventListener('change', sync);
      sync();
      button.addEventListener('click', async () => {
        if (busy || !terms.checked) return;
        busy = true;
        sync();
        button.textContent = config.saving;
        status.textContent = '';
        const rows = [...root.querySelectorAll('[data-preorder-key]')];
        const grouped = new Map();
        for (const row of rows) {
          const quantity = Number(row.querySelector('[name^="updates["]').value);
          const id = row.dataset.variantId;
          const item = grouped.get(id) || { handle: row.dataset.productHandle, variantId: id, quantity: 0 };
          item.quantity += quantity;
          grouped.set(id, item);
        }
        const items = [...grouped.values()].sort((a,b) => a.variantId.localeCompare(b.variantId));
        const fingerprint = JSON.stringify({ instagram: username(), items });
        try {
          if (root.dataset.currency !== 'MXN') throw new Error(config.currencyError);
          try { const stored = JSON.parse(localStorage.getItem(storageKey) || 'null'); if (stored?.fingerprint === fingerprint) attempt = stored; } catch {}
          if (!attempt || attempt.fingerprint !== fingerprint) attempt = { fingerprint, requestId: crypto.randomUUID() };
          try { localStorage.setItem(storageKey, JSON.stringify(attempt)); } catch {}
          const response = await fetch(config.endpoint, {
            method: 'POST', credentials: 'omit', signal: AbortSignal.timeout(45000), headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ requestId: attempt.requestId, instagram: username(), acceptedTerms: true, termsVersion: '2026-09-10', items })
          });
          const data = await response.json();
          if (!response.ok || !data.ok || !/^FFP-\d+$/.test(data.folio)) throw new Error(data.error || config.error);
          root.querySelector('[data-ff-folio]').textContent = data.folio;
          root.querySelector('[data-ff-cart-main]').hidden = true;
          const success = root.querySelector('[data-ff-request]');
          success.hidden = false;
          success.setAttribute('tabindex','-1');
          success.focus();
          const note = success.querySelector('[data-ff-request-status]');
          try {
            const cartRoot = window.Shopify?.routes?.root || '/';
            const cartResponse = await fetch(cartRoot + 'cart.js', { cache: 'no-store' });
            if (!cartResponse.ok) throw new Error('cart');
            const current = await cartResponse.json();
            const updates = {};
            let changed = false;
            for (const row of rows) {
              const line = current.items.find(item => item.key === row.dataset.preorderKey);
              if (!line) continue;
              if (line.quantity !== Number(row.querySelector('[name^="updates["]').value)) { changed = true; continue; }
              updates[line.key] = 0;
            }
            if (Object.keys(updates).length) {
              const cleared = await fetch(cartRoot + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
              if (!cleared.ok) throw new Error('cart');
              const cart = await cleared.json();
              document.querySelectorAll('.ff-bag span').forEach(count => { count.textContent = String(cart.item_count); count.hidden = !cart.item_count; });
            }
            if (changed) throw new Error('changed');
            try { localStorage.removeItem(storageKey); } catch {}
          } catch { note.textContent = config.cleanupError; }
        } catch (error) {
          status.textContent = error instanceof TypeError || error?.name === 'TimeoutError' ? config.error : error.message || config.error;
          button.textContent = config.submit;
          busy = false;
          sync();
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["feelfit-shopping-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ffShoppingNavigationReady) return;
    window.ffShoppingNavigationReady = true;
    const key = 'ff_shopping_origin_v2';
    const parameter = 'ff_from';
    let memory = '';

    const localURL = value => {
      if (!value || typeof value !== 'string' || value.length > 4096) return null;
      try {
        const url = new URL(value, window.location.origin);
        return url.origin === window.location.origin && !url.username && !url.password ? url : null;
      } catch { return null; }
    };
    const sectionURL = value => {
      const url = localURL(value);
      if (!url) return '';
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+(?:\/[^/]+)?\/?$/i.test(url.pathname)) return '';
      if (url.pathname.includes('/products/')) return '';
      url.searchParams.delete(parameter);
      url.searchParams.delete('variant');
      return url.pathname + url.search + url.hash;
    };
    const sourceFrom = value => {
      const url = localURL(value);
      if (!url) return '';
      const explicit = sectionURL(url.searchParams.get(parameter));
      if (explicit) return explicit;
      const productAt = url.pathname.indexOf('/products/');
      if (productAt >= 0) return sectionURL(url.pathname.slice(0, productAt));
      return sectionURL(url.href);
    };
    const saved = () => {
      try { return sectionURL(sessionStorage.getItem(key)) || memory; }
      catch { return memory; }
    };
    const remember = value => {
      const url = sectionURL(value);
      if (!url) return '';
      memory = url;
      try { sessionStorage.setItem(key, url); } catch {}
      return url;
    };
    const resolve = () => {
      const here = new URL(window.location.href);
      const context = document.querySelector('[data-ff-shopping-context]');
      const currentSection = sectionURL(here.href);
      if (currentSection) return remember(currentSection);
      const explicit = sectionURL(here.searchParams.get(parameter));
      if (explicit) return remember(explicit);
      const referrerSource = sourceFrom(document.referrer);
      const collection = sectionURL(context?.dataset.collectionUrl);
      if (collection) {
        const previous = saved();
        if (localURL(previous)?.pathname === localURL(collection)?.pathname) return previous;
        return remember(collection);
      }
      if (referrerSource) return remember(referrerSource);
      if (here.pathname.includes('/products/')) {
        const referrer = localURL(document.referrer);
        if (referrer?.pathname.includes('/products/') && saved()) return saved();
        return remember(context?.dataset.fallbackUrl);
      }
      return saved() || sectionURL(document.querySelector('[data-ff-continue]')?.getAttribute('href'));
    };
    const withSource = (value, source) => {
      const url = localURL(value);
      if (!url || !source) return value;
      url.searchParams.set(parameter, source);
      return url.pathname + url.search + url.hash;
    };
    const linkSource = (link, source) => {
      if (!sectionURL(window.location.href)) return source;
      const section = link.closest('.ff-birthday[id], [data-ff-shopping-section][id]');
      if (!section) return source;
      const url = localURL(source);
      url.hash = section.id;
      return url.pathname + url.search + url.hash;
    };
    const prepareLink = (link, source) => {
      const context = document.querySelector('[data-ff-shopping-context]');
      const url = localURL(link.getAttribute('href'));
      if (!url) return;
      if (link.matches('[data-ff-continue]')) {
        if (source) link.href = source;
      } else if (url.pathname.includes('/products/') || url.pathname === context?.dataset.cartUrl) {
        link.href = withSource(url.href, linkSource(link, source));
      }
    };
    const prepareForm = (form, source) => {
      if (!source || !form.matches('.ff-product-form')) return;
      const context = document.querySelector('[data-ff-shopping-context]');
      if (!context?.dataset.cartUrl) return;
      let input = form.querySelector('input[name="return_to"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'return_to';
        form.append(input);
      }
      input.value = withSource(context.dataset.cartUrl, source);
    };
    const refresh = () => {
      const source = resolve();
      document.querySelectorAll('a[href]').forEach(link => prepareLink(link, source));
      document.querySelectorAll('.ff-product-form').forEach(form => prepareForm(form, source));
    };
    document.addEventListener('click', event => {
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      const source = linkSource(link, resolve());
      remember(source);
      prepareLink(link, source);
    }, true);
    document.addEventListener('submit', event => prepareForm(event.target, resolve()), true);
    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('pageshow', refresh);
    window.addEventListener('hashchange', refresh);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
    else refresh();
  })();
  } catch(e) { console.error(e); }
})();

})();
